
import React from 'react';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import PageTransition from '@/components/transitions/PageTransition';
import useScrollRestoration from '@/hooks/useScrollRestoration';
import ScrollObserver from '@/components/effects/ScrollObserver';


interface MainLayoutProps {
  children: React.ReactNode;
}

// Optimized loading indicator
const LoadingIndicator = () => (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-pulse flex flex-col items-center">
      <div className="h-12 w-12 bg-joerg-500/20 rounded-full"></div>
      <div className="mt-4 text-joerg-600">Wird geladen...</div>
    </div>
  </div>
);

/**
 * Main layout component with optimized loading
 */
const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  // Restore scroll position when navigating
  useScrollRestoration();
  
  
  return (
    <>
      <Navbar />
      
      {/* Direct rendering for crawler compatibility - no JavaScript transitions */}
      <main className="page-content-padding flex-grow">
        {children}
      </main>
      
      <Footer />
      
      <ScrollObserver />
    </>
  );
};

export default MainLayout;
